export const environment = {
  production: true,
  API_BASE_PATH: 'https://api.oak-events.com/api',
  ALLOWED_DOMAINS: ['api.oak-events.com'],
  NATS_SERVERS: ['wss://oak-fra1-db-01.digitalforest.it'],
  SENTRY_DSN: 'https://e99ed5fe46b8b93fd3a50529b54468c2@o4503958405709824.ingest.us.sentry.io/4509452112363520',
  DEFAULT_THEME_COLORS: {
    primary: '#0d6efd',
    secondary: '#6c757d',
    success: '#198754',
    warning: '#ffc107',
    danger: '#dc3545',
    basic: '#17a2b8',
    box: '#f8f9fa',
  },
  MAX_FILE_SIZE_EXCEL: 5242880, // 5MB for Excel/data imports
  MAX_FILE_SIZE_TICKETS: 52428800, // 50MB for ticket attachment imports
  ELEVENLABS_CHATBOT_AGENT_ID: 'agent_01k0e9jkypfdmrjvy3z6fmz17b',
  NATS_CREDS: `-----BEGIN NATS USER JWT-----
eyJ0eXAiOiJKV1QiLCJhbGciOiJlZDI1NTE5LW5rZXkifQ.eyJqdGkiOiJRS0lLVEc1VTJTQ0tHNVpENEpYQ05DNlI1WkVDTUxMUzVaUUFSU1JSU1FMUkVXRk9ZUklBIiwiaWF0IjoxNzEyMjUwMTEzLCJpc3MiOiJBREM2QTZISElVVFlFTkNaS09WN05aNEZKVTM1T1RCSkYzVUtRNlVTVkNFTFhRRTNQTzVUNUJKNiIsIm5hbWUiOiJwcm9qZWN0NDIiLCJzdWIiOiJVQUhTSDVQUVRYTk9MRDdXWVJVRjJLSkFIWlBZUlhLUk5KT1gyNFVMN1dPSkdHTUpXQURQUjJSNSIsIm5hdHMiOnsicHViIjp7fSwic3ViIjp7fSwic3VicyI6LTEsImRhdGEiOi0xLCJwYXlsb2FkIjotMSwiaXNzdWVyX2FjY291bnQiOiJBQkFDM1NFM09KWldCQks3NFVLUjdKSjJBWlNYVFFGM0VLMkc2VVk1Nk5MSVhLWUVKWkYzRkdTUiIsInR5cGUiOiJ1c2VyIiwidmVyc2lvbiI6Mn19.96qv63oPFoHGHYFO6Lv8yxp3y68cmnKk8FQhGv4Vd_vccJZJVl_RAlhOZjoMaGL-d8jyMgU7ZE0-CKDL_OI1AQ
------END NATS USER JWT------

************************* IMPORTANT *************************
NKEY Seed printed below can be used to sign and prove identity.
NKEYs are sensitive and should be treated as secrets.

-----BEGIN USER NKEY SEED-----
SUAGQRYPB6OJDXEZR3JZB5RUF6D2O7BQ5JPNE3PNHAYQM572QZVLNRGQRI
------END USER NKEY SEED------

*************************************************************
`,
};
